import React from 'react';
import { Box, Typography } from '@material-ui/core';

export interface SubtitleProps {
  className?: string;
  id: string;
  label?: React.ReactNode;
  description?: React.ReactNode;
}

export const FormSubtitle: React.FC<SubtitleProps> = ({
  className = '',
  label,
  description,
}) => {
  return (
    <div className={className}>
      <Typography variant="subtitle1" component="h3">
        {label}
      </Typography>
      {description && <Box>{description}</Box>}
    </div>
  );
};
